import React from 'react'


function Photography() {
  const photo = [
    {
      id: 1,
      src: "https://res.cloudinary.com/dkqxnquga/image/upload/v1693990593/subhayu_csyjud.jpg",
      speaker: "SUBHAYU DASGUPTA",
      designation: "Photographer",
      workshop: "Photography Workshop",
      date: "Date:3:00pm,10th September 2023",
      venue: "Venue:LA,Nit Rourkela",
    },
  ];
 
  return (
    <div className="photography bg-[#4D4D4D]   w-full min-h-screen relative ">
      {/* Category */}
      <div className=" pt-20 lg:pt-32 px-auto lg:pl-10 w-fit h-1/3 relative">
        <img
          src="https://res.cloudinary.com/dkqxnquga/image/upload/v1693719224/Group_9_2_1_hxrflt.png"
          alt="photography"
        ></img>
        <h1 className=" absolute text-outfit text-white text-3xl sm:text-7xl lg:text-8xl  font-black bottom-1 md:bottom-2 left-[12%] lg:left-20 tracking-widest">
          PHOTOGRAPHY
        </h1>
      </div>

      {/* Workshop Description */}

      {photo.map(({ id,src, speaker, designation, workshop, date, venue }) => (
        <div
          key={id}
          className="w-full h-1/3 sm:max-w-2xl lg:max-w-xl xl:max-w-3xl flex flex-col md:flex-row items-center justify-start text-outfit mt-10 mb-2 mx-auto xl:ml-10 "
        >
          <div className=" w-40 h-40 md:w-64 md:h-64 xl:w-80 xl:h-80 bg-[url('https://res.cloudinary.com/dkqxnquga/image/upload/v1693722175/download_ufugti.jpg')] bg-no-repeat bg-cover bg-center rounded-full border-8 border-[#313030]  hover:scale-110 duration-150 ">
            <img src={src} alt="music" className="w-full h-full rounded-full" />
          </div>

          <div className=" text-center md:text-left text-white h-2/3  mt-6 md:ml-10 ">
            <h className="text-3xl md:text-6xl lg:text-4xl font-extrabold ">
              {speaker}
            </h>
            <h1 className="text-2xl md:text-5xl  lg:text-3xl font-bold ">
              {designation}
            </h1>
            <br />
            <div className="text-md md:text-2xl lg:text-xl font-semibold leading-none">
              <h1>{workshop}</h1>
              <h1>{date}</h1>
              <h1>{venue}</h1>
            </div>
          </div>
        </div>
      ))}

      {/* Category Image*/}
      <div className="   sm:ml-[4%]  lg:ml-[12%] xl:absolute xl:bottom-2 xl:right-0 ">
        <img
          src="https://res.cloudinary.com/dkqxnquga/image/upload/v1693644139/Group_2_behv99.png"
          alt="photography"
        ></img>
      </div>
    </div>
  );
}

export default Photography